import React from "react";
import { Modal, Form, Input } from "antd";
import { AutoResizeTextArea } from "../../../components/AutoResizeTextArea";

import { submitFormData } from "../../../HOCs";
import { reportUser } from "../../../routes/Chat/chat.ducks";

const defaultSettings = {
  form: {
    description: {
      label: "Detaljno opiši spornu situaciju",
      field: "description",
      rowCount: 5,
      rules: [
        {
          min: 4,
          max: 600,
          required: true,
          message: "Opis ne može biti dulji od 600 znakova i kraći od 4."
        }
      ]
    },

    submitButton: {
      text: "Prijavi"
    },
    cancelButton: {
      text: "Odustani"
    }
  },
  modal: {
    title: "Prijavi korisnika"
  }
};

function UserReportForm({
  visible,
  form,
  settings,
  onCancel,
  onSubmit,
  chatId,
}) {
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSubmit = () => {
    form.validateFields(async (err: any, values: any) => {
      if (err) {
        return;
      }

    onSubmit({chatId, description: values.description}, status => {
      if (status) {
        onCancel()
      }
    });
    });
  };


  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText={settings.form.submitButton.text}
      cancelText={settings.form.cancelButton.text}
      title={settings.modal.title}
    >
      <Form layout="vertical">
        <span className="control-title required">
          {settings.form.description.label}
        </span>
        <Form.Item>
          {form.getFieldDecorator(settings.form.description.field, {
            rules: settings.form.description.rules
          })(
            <AutoResizeTextArea
              rows={settings.form.description.rowCount}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
}

UserReportForm.defaultProps = {
  settings: defaultSettings,
  visible: false
};

export default submitFormData(Form.create()(UserReportForm), reportUser);



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/UserReportForm.tsx